var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgArrowRight(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 31,
    viewBox: "0 0 42 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.144836 16.1171H21C21 17.5137 20.5345 19.562 17.881 19.562C15.2276 19.562 0.144836 19.562 0.144836 19.562L0.144836 16.1171Z",
    fill: "#D9D9D9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0.144836 16.1171H21C21 17.5137 20.5345 19.562 17.881 19.562C15.2276 19.562 0.144836 19.562 0.144836 19.562L0.144836 16.1171Z",
    fill: "url(#paint0_linear_115_76)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21 12.9516L39.0621 12.9516V16.1171H21V12.9516Z",
    fill: "#D9D9D9"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M21 12.9516L39.0621 12.9516V16.1171H21V12.9516Z",
    fill: "url(#paint1_linear_115_76)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M26.7763 0.0102539L41.6548 14.8888L39.4165 17.1271L24.538 2.24861L26.7763 0.0102539Z",
    fill: "#D9D9D9"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M26.7763 0.0102539L41.6548 14.8888L39.4165 17.1271L24.538 2.24861L26.7763 0.0102539Z",
    fill: "url(#paint2_linear_115_76)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M24.5379 27.8301L39.55 12.818L41.7884 15.0564L26.7763 30.0685L24.5379 27.8301Z",
    fill: "#D9D9D9"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M24.5379 27.8301L39.55 12.818L41.7884 15.0564L26.7763 30.0685L24.5379 27.8301Z",
    fill: "url(#paint3_linear_115_76)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_115_76",
    x1: 37.0786,
    y1: -3.51987,
    x2: 18.0389,
    y2: 39.8757,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4383FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A0D1F4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_115_76",
    x1: 37.0786,
    y1: -3.51987,
    x2: 18.0389,
    y2: 39.8757,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4383FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A0D1F4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_115_76",
    x1: 37.0786,
    y1: -3.51987,
    x2: 18.0389,
    y2: 39.8757,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4383FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A0D1F4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_115_76",
    x1: 37.0786,
    y1: -3.51987,
    x2: 18.0389,
    y2: 39.8757,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4383FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A0D1F4"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRight);
export default __webpack_public_path__ + "static/media/arrowRight.2e93a71d3b2392e4d12143a40bff9f4f.svg";
export { ForwardRef as ReactComponent };